export const browserCallParameters = (data, userDisplay = 'Agent', conversationId = null) => {
  const reference = data?.conversation_id || conversationId;
  if (!reference || !data?.identity || !data?.call_authorization ||
      (conversationId && data.conversation_id && conversationId !== data.conversation_id)) {
    throw new Error('Der sichere Anruf konnte nicht vorbereitet werden. Bitte erneut versuchen.');
  }
  return {
    ConversationId: reference,
    CallAuthorization: data.call_authorization,
    UserId: data.identity,
    UserDisplay: userDisplay || 'Agent',
  };
};
